module.exports = __webpack_public_path__ + "img/172-60ade7.png";